import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { debounce } from 'lodash';
import { Card } from 'react-bootstrap-5';

import OverlayCard from './overlay_card';
import { findOffMarketProperty } from 'bundles/connect/helpers/connect_api';

function OffMarketOverlayCard({ offMarketResults, offMarketHoverPropertyId }) {
  const [property, setProperty] = useState();

  const fetchProperty = useCallback(
    debounce((id) => {
      const propertyFromMemory = (offMarketResults || []).find(property => property.propertyId === id);

      if (propertyFromMemory) {
        setProperty(propertyFromMemory);
      } else {
        findOffMarketProperty(id).then(setProperty);
      }
    }, 500),
    []
  );

  useEffect(() => {
    if (offMarketHoverPropertyId && offMarketHoverPropertyId !== property?.propertyId) {
      fetchProperty(offMarketHoverPropertyId);
    }
  }, [offMarketHoverPropertyId]);

  if (!offMarketHoverPropertyId || !property || offMarketHoverPropertyId !== property.propertyId) return null;

  return (
    <OverlayCard heightOffset={30} lat={property.latitude} lng={property.longitude}>
      <Card.Body className="p-2">
        <div>
          <div className="result-address fw-bold" style={{ fontSize: '1.05rem' }}>
            {property.address}
          </div>
          <p>{property.city}, {property.state} {property.zip}</p>
          {property.highlights.map((highlight, i) => (
            <React.Fragment key={i}>
              <span> {highlight.value} {highlight.label} </span>
              {i < property.highlights.length - 1 && <span className="fw-bold mx-1"> | </span>}
            </React.Fragment>
          ))}
        </div>
      </Card.Body>
    </OverlayCard>
  );
}

OffMarketOverlayCard.propTypes = {
  offMarketHoverPropertyId: PropTypes.number,
  offMarketResults: PropTypes.arrayOf(PropTypes.shape({
    propertyId: PropTypes.number.isRequired
  }))
};

const mapStateToProps = ({ results: { offMarketResults }, ui: { offMarketHoverPropertyId } }) => {
  return { offMarketHoverPropertyId, offMarketResults };
};

export default connect(mapStateToProps)(OffMarketOverlayCard);
